import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js